module.exports = __webpack_public_path__ + "static/media/womenshealth.85cdfa78.png";